<template>
  <div>

    <h3>Step 1/5</h3>

    <loader v-if="loader"></loader>
    <a id="upload" v-else>
      Upload Profile Photo
    </a>

    <img id="photo"/>

  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import {mapGetters} from 'vuex'
  //
  import loader from '@/components/loaders/fullscreenLoader'
  //
  export default {
    //
    methods:{
      ...mapMutations([

      ])
    },
    computed:{
      ...mapGetters([
        'loader'
      ])
    },
    created(){

    },
    mounted(){
      this.$store.commit('uploadImage_1')
    },
    components:{
      loader
    }
    //
  }
</script>



// WEBPACK FOOTER //
// uploadImage_1.vue?53d5f4a4